import React from 'react'

interface TestimonialCardProps {
  text: string
  userName: string
  userTitle: string
  userImage?: string
  rating?: number
  className?: string
}

const TestimonialCard: React.FC<TestimonialCardProps> = ({
  text,
  userName,
  userTitle,
  userImage,
  rating = 5,
  className = '',
}) => {
  return (
    <div
      className={`flex-shrink-0 w-[80vw] max-w-sm md:w-96 bg-[#EEF0F2] rounded-lg shadow-sm border border-gray-100 p-6 ${className}`}
    >
      {/* Star Rating */}
      <div className='mb-3 flex items-center'>
        {[...Array(5)].map((_, i) => (
          <svg
            key={i}
            className={`w-5 h-5 ${
              i < rating ? 'text-yellow-400' : 'text-gray-300'
            }`}
            fill='currentColor'
            viewBox='0 0 20 20'
          >
            <path d='M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z' />
          </svg>
        ))}
      </div>

      <div className='mb-4'>
        <p className='text-[#120E14] text-[18px] text-start leading-relaxed line-clamp-4'>
          {text}
        </p>
      </div>

      {/* User Profile */}
      <div className='flex items-center space-x-3'>
        {userImage ? (
          <img
            src={userImage}
            alt={userName}
            className='w-10 h-10 rounded-full object-cover'
          />
        ) : (
          <div className='w-10 h-10 rounded-full bg-gradient-to-br from-[#001B38] to-[#002a50] flex items-center justify-center text-white font-semibold text-sm'>
            {userName.charAt(0).toUpperCase()}
          </div>
        )}
        <div className='flex flex-col items-start justify-center'>
          <h4 className='text-sm font-semibold text-gray-900'>{userName}</h4>
          <p className='text-xs text-gray-500'>{userTitle}</p>
        </div>
      </div>
    </div>
  )
}

export default TestimonialCard
